import { render, staticRenderFns } from "./ShopCart.vue?vue&type=template&id=cdfea47c&scoped=true"
import script from "./ShopCart.vue?vue&type=script&lang=js"
export * from "./ShopCart.vue?vue&type=script&lang=js"
import style0 from "./ShopCart.vue?vue&type=style&index=0&id=cdfea47c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfea47c",
  null
  
)

export default component.exports